<template>
  <div class>
    <div class="leftEye eyeItem">
      <el-card class="box-card" shadow="hover">
        <div slot="header" class="clearfix">
          <span>右眼(OD)</span>
          <el-button
            style="float: right; padding: 3px 0"
            type="text"
            @click="toSlice(true,'right')"
          >进入阅片</el-button>
        </div>
        <div class="l_bd">
          <div class="s_main_content">
            <div
              v-for="(item,index) in sliceList.right"
              :key="item.id"
              class="s_main_item"
              @click="toSlice(true,'right',index)"
            >
              <div class="box">
                <span></span>
                图{{index+1}}
              </div>
              <img :src="item.image" />
            </div>
          </div>
        </div>
      </el-card>
    </div>
    <div class="rightEye eyeItem">
      <el-card class="box-card" shadow="hover">
        <div slot="header" class="clearfix">
          <span>左眼(OS)</span>
          <el-button
            style="float: right; padding: 3px 0"
            type="text"
            @click="toSlice(true,'left')"
          >进入阅片</el-button>
        </div>
        <div class="r_bd">
          <div class="s_main_content">
            <div
              v-for="(item,index) in sliceList.left"
              :key="item.id"
              class="s_main_item"
              @click="toSlice(true,'left',index)"
            >
              <div class="box">
                <span></span>
                图{{index+1}}
              </div>
              <img :src="item.image" />
            </div>
          </div>
        </div>
      </el-card>
    </div>
    <!-- 弹框 -->
    <el-dialog title="阅片模式" :visible.sync="sliceItem" width="90%" :before-close="handleClose">
      <div class="slice_warpper">
        <div class="curImg">
          <div class="_warpper">
            <div class="con fileBg">
              <div class="box">
                <span></span>
                图{{cur.index}}
              </div>
              <!-- 亮度调节 -->
              <div class="bright">
                <el-slider :min="0" :max="100" v-model="brightness" vertical height="100px"></el-slider>
              </div>
              <div
                class="myedit setjia"
                ref="myedit"
                @mousedown.prevent="onMousedown"
                @mousemove="onMousemove"
                @contextmenu.prevent
                v-show="error == 2"
              >
                <img ref="curImg" id="curImg" :src="cur.curImg" alt srcset />
                <!-- 异常标记 -->
                <span
                  class="myedit-span"
                  v-for="(item, index) in mydata"
                  :key="index"
                  :style="getSpanStyle(item)"
                  @contextmenu.prevent="onContextmenu(item, $event)"
                ></span>
              </div>
              <!-- 未见异常图片 -->
              <img ref="curImg" v-show="error == 1" :src="cur.curImg" alt srcset />
            </div>
          </div>
        </div>
        <!-- 右边图片列表 -->
        <div class="list">
          <div
            v-for="(slice,index) in curList"
            :key="slice.index"
            class="text item"
            @click="sliceItemChoose(slice,index)"
          >
            <div class="box">
              <span></span>
              图{{index+1}}
            </div>
            <img :src="slice.image" alt srcset />
          </div>
        </div>
        <!-- 选项表单 -->
        <div class="errorForm">
          <el-card class="box-card" style="width:100%" shadow="never">
            <div slot="header">
              <el-radio v-model="error" label="1" border>未见明显异常</el-radio>
              <el-radio v-model="error" label="2" border>异常</el-radio>
            </div>
            <div class="s_bd" v-if="error == 1">
              <el-checkbox-group style="line-height:30px;" v-model="checkedSymptoms">
                <el-checkbox
                  style="display:block"
                  v-for="symptom in symptoms"
                  :label="symptom.id"
                  :key="symptom.id"
                >{{symptom.name}}</el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="s_bd" v-else>
              <el-form label-width="80px">
                <el-form-item label="第一步：">请先在左侧图中添加标记</el-form-item>
                <el-form-item label="第二步：">
                  <el-select v-model="value" placeholder="请选择位置">
                    <el-option
                      v-for="item in options"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="第三步：">
                  <el-cascader
                    v-model="item"
                    :options="list"
                    placeholder="请选择病历"
                    :props="{ expandTrigger: 'hover',value: 'id', label: 'title'}"
                    @change="handleChange"
                  ></el-cascader>
                </el-form-item>
                <div class="msg">
                  <div class="m_item" v-for="item in textErrorList" :key="item.index">
                    <el-alert :title="item.title"></el-alert>
                  </div>
                </div>
              </el-form>
            </div>
            <div class="footer">
              <el-button
                type="success"
                style="background:rgb(0, 175, 255);border:rgb(0, 175, 255);width:100%;"
                @click="submitReport()"
              >提交</el-button>
            </div>
          </el-card>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { readfilmPicList, reportAdd, getSystem, eyeCase } from "@/api";
export default {
  name: "",
  components: {},
  props: {
    casesId: {
      type: [Number, String],
      default: "0"
    }
  },
  data() {
    return {
      sliceItem: false,
      cur: {
        id: "",
        index: "",
        curImg: ""
      },
      brightness: 0,
      checkedSymptoms: [],
      sliceList: {},
      curList: [],
      symptoms: [],
      error: "1",
      options: [],
      value: "",
      item: [],
      list: [],
      mymenu: { current: null, style: { left: 0, top: 0 } },
      mydata: [],
      textErrorList: [],
      textErrorData: [],
      imgErrList: [],
      errList: []
    };
  },
  mounted() {
    document.addEventListener("mouseup", this.onMouseup);
    setTimeout(() => {
      this.initReadFilmList();
      this.initPosition();
      this.initSick();
    }, 300);
  },
  beforeDestroy() {
    document.removeEventListener("mouseup", this.onMouseup);
  },
  created() {},
  activited() {},
  update() {},
  beforeRouteUpdate() {},
  methods: {
    //初始化症状，位置
    initPosition() {
      getSystem().then(res => {
        this.options = res.result.eye_position;
        this.symptoms = res.result.eye_normal;
      });
    },
    //获取病例
    initSick() {
      eyeCase({}).then(res => {
        this.list = res.data;
      });
    },
    //初始化图片列表
    initReadFilmList() {
      let data = {
        cases_id: this.casesId
      };
      readfilmPicList(data).then(res => {
        this.sliceList = res.data;
      });
    },
    //异常病例选择操作
    handleChange(value) {
      console.log("value:", value);
      if (!this.value) {
        this.$message({
          type: "error",
          message: "请先完成第二步"
        });
        return;
      }
      let obj = {
        title: ""
      };
      if (this.value) {
        obj.title = this.value;
      }
      if (value[0]) {
        obj.title += "," + value[0];
      }
      if (value[1]) {
        obj.title += "," + value[1];
      }
      var curList = this.list.filter(
        (item, index, arr) => item.id == value[0]
      )[0];
      console.log("curList:", curList);
      let data = {
        title:
          this.getLabel(this.options, this.value) +
          this.getLabel(this.list, value[0]) +
          this.getLabel(curList.children, value[1])
      };
      this.value = "";
      this.item = [];
      this.textErrorList.push(data);
      this.textErrorData.push(obj);
    },
    //传入列表和id返回label
    getLabel(list, id) {
      console.log("list:", list, id);
      if (list == "" || list == undefined) {
        return "";
      } else {
        if (list.filter((item, index, arr) => item.id == id)[0].name) {
          return list.filter((item, index, arr) => item.id == id)[0].name;
        } else {
          return list.filter((item, index, arr) => item.id == id)[0].title;
        }
      }
    },
    //切换图片
    sliceItemChoose(item, index) {
      this.cur.curImg = item.image;
      this.cur.index = index + 1;
      this.cur.id = item.id;
      this.mydata = [];
      this.getGetErrData(item)
    },
    //标注数据保存
    saveData(callback) {
      /**
       * 数组组装
       */
      let item = {
        id: this.cur.id,
        type: this.error,
        remark: []
      };
      item.remark.push(this.mydata);
      this.errList.push(item);
      callback && callback();
    },
    //输入重置
    reast() {
      //TODO:
      this.checkedSymptoms = [];
      this.value = "";
      this.item = [];
      this.textErrorList = [];
    },
    //阅片关闭
    handleClose(done) {
      done();
    },
    //进入阅片
    toSlice(status, type,index) {
      this.sliceItem = status;
      if (status === true) {
        this.$nextTick(() => {
          if(index){
            let item = this.sliceList[type][index]
            this.getGetErrData(item)
            this.cur.index = index+1;
            this.cur.curImg = this.sliceList[type][index].image;
            this.curList = this.sliceList[type];
            this.cur.id = this.sliceList[type][index].id;
            
          }else{
            this.cur.index = 1;
            if (this.sliceList.right[0] && type == "right") {
              let item = this.sliceList.right[0]
              this.cur.curImg = this.sliceList.right[0].image;
              this.curList = this.sliceList.right;
              this.cur.id = this.sliceList.right[0].id;
              this.getGetErrData(item)
            } else if (this.sliceList.left[0] && type == "left") {
              let item = this.sliceList.left[0]
              this.cur.curImg = this.sliceList.left[0].image;
              this.curList = this.sliceList.left;
              this.cur.id = this.sliceList.left[0].id;
              this.getGetErrData(item)
            } else {
              this.cur.curImg = "";
              this.$message({
                type: "error",
                message: "暂无阅片图片"
              });
            }
          }
        });
      };
    },
    //更新错误标记
    getGetErrData(item){
      if(item.remark){
        this.mydata = item.remark[0];
        this.error = '2'
      }else{
        this.error = '1'
        this.mydata = [];
      };
    },  
    //标记提交
    submitReport() {
      let data = {
        errList: this.errList,
        textData:
          this.textErrorData.length == 0
            ? this.checkedSymptoms
            : this.textErrorData
      };
      this.sliceItem = false;
      this.$emit("on-submit", data);
    },
    //标记操作
    onMousedown(e) {
      this.mymenu.current = null;
      let { x, y } = this.getXY(e);
      this.currentItem = { x, y, w: 0, h: 0, now: Date.now() };
      this.startPos = { x, y };
      this.mydata.push(this.currentItem);
      this.saveData();
    },
    onMousemove(e) {
      if (!this.currentItem) return;
      let { x, y } = this.getXY(e);
      this.currentItem.w = Math.abs(x - this.startPos.x);
      this.currentItem.h = Math.abs(y - this.startPos.y);
    },
    onMouseup(e) {
      this.currentItem = this.startPos = null;
      this.mydata = this.mydata.filter(_ => _.w > 10 && _.h > 10);
    },
    onContextmenu(item, e) {
      this.mymenu = {
        current: item,
        style: {
          top: e.clientY + "px",
          left: e.clientX + "px"
        }
      };
    },
    onRemoveItem() {
      this.mydata.splice(this.mydata.indexOf(this.mymenu.current), 1);
      this.mymenu = { ...this.mymenu, current: null };
    },
    getSpanStyle(item) {
      return {
        width: `${item.w}px`,
        height: `${item.h}px`,
        top: `${item.y}px`,
        left: `${item.x}px`
      };
    },
    getXY(e) {
      let rect = this.$refs.myedit.getBoundingClientRect();
      return {
        x: e.clientX - rect.left,
        y: e.clientY - rect.top
      };
    }
  },
  filter: {},
  computed: {},
  watch: {
    //图片亮度监听
    brightness(val) {
      var curData = (100+Number(val)) + "%";
      var curImg = this.$refs.curImg;
      curImg.style.WebkitFilter = `brightness(${curData})`;
    }
  }
};
</script>

<style lang="scss" scoped>
.s_main_content {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-content: center;
}
.s_main_item {
  position: relative;
  img {
    width: 160px;
  }
  .box {
    position: absolute;
    color: #fff;
    span {
      width: 15px;
      height: 15px;
      margin: 5px;
      vertical-align: middle;
      background: #fff;
      display: inline-block;
    }
  }
}
._warpper {
  padding-bottom: 100%;
  height: 0;
  width: 100%;
  position: relative;
  .con {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    img{
      width:100%;
      height:100%;
    }
  }
}
.slice_warpper {
  display: flex;
  .list {
    height: 540px;
    overflow: hidden;
    overflow-y: scroll;
    margin: 0 20px;
    flex: 0 0 15%;
    .item {
      position: relative;
      img {
        width: 100%;
      }
      .box {
        position: absolute;
        color: #fff;
        span {
          width: 15px;
          height: 15px;
          margin: 5px;
          vertical-align: middle;
          background: #fff;
          display: inline-block;
        }
      }
    }
  }
  .curImg {
    position: relative;
    width: 50%;
    .box {
      position: absolute;
      right: 10px;
      color: #fff;
      z-index: 100;
      span {
        width: 15px;
        height: 15px;
        margin: 5px;
        vertical-align: middle;
        background: #fff;
        display: inline-block;
      }
    }
    .bright {
      position: absolute;
      top: 10px;
      z-index: 100;
    }
    .myedit {
      position: relative;
      .myedit-span {
        position: absolute;
        border: 1px dashed #00afff;
        // background: url("../../assets/images/add.png") no-repeat center center;
        background-size: contain;
      }
      .mycanvas {
        border: 1px solid pink;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }
  .errorForm {
    flex: 0 0 40%;
    margin-left: 20px;
    .msg {
      .m_item {
        margin: 15px 0;
      }
    }
  }
}
.rightEye {
  margin-top: 20px;
}
.setjia {
  cursor: crosshair;
  height: 100%;
}
.fileBg {
  background-image: url("../../assets/images/filmBg.png");
  background-repeat: repeat;
}
</style>
